import React, { useState } from 'react';
import { Card, Form, Input, Button, Switch, Space, InputNumber, Alert, Select } from 'antd';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { createTruck } from '../../store/slices/truckSlice';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const AddTruck = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const onSubmit = async (values) => {
        setLoading(true);
        setAlertMessage("");
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));

            const resultAction = await dispatch(createTruck({
                truck_num : values.truckNum,
                // total_orders : values.totalOrders,
                orders_per_day : values.ordersPerDay,
                cbm: values?.cbm,
                type: values?.type,
            }));

            if (createTruck.fulfilled.match(resultAction)) {
                // navigate('/dashboard');
                setAlertMessage(resultAction?.payload?.message || 'Truck created successfully!');
                setAlertType('success');
                setTimeout(() => {
                    setAlertMessage('');
                }, 4000);
            } else {
                setAlertMessage(resultAction?.payload?.error || 'Error creating truck');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error creating truck.');
            setAlertType('error');
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Trucks</h1>
            <Card title="Add Truck" style={{ marginBottom: 16 }}>
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={onSubmit}
                >
                    <Form.Item
                        label="Truck Number"
                        name="truckNum"
                        rules={[{ required: true, message: 'Please input truck number!' }]}
                    >
                        <Input placeholder="Enter truck number" />
                    </Form.Item>
                    {/* <Form.Item
                        label="Total Orders"
                        name="totalOrders"
                        rules={[{ required: true, message: 'Please input total orders!' }]}
                    >
                        <InputNumber placeholder="Enter total orders" style={{ width : "100%" }} />
                    </Form.Item> */}
                    <Form.Item
                        label="Orders Per Day"
                        name="ordersPerDay"
                        rules={[{ required: true, message: 'Please input order per day!' }]}
                    >
                        <InputNumber placeholder="Enter order per day" style={{ width : "100%" }} />
                    </Form.Item>
                    <Form.Item
                        label="CBM Value"
                        name="cbm"
                        rules={[{ required: true, message: 'Please input cbm value!' }]}
                    >
                        <Input placeholder="Enter cbm value" />
                    </Form.Item>
                    <Form.Item
                        label="Type"
                        name="type"
                        rules={[{ required: true, message: 'Please select type' }]}
                    >
                        <Select
                            placeholder="Select type"
                            options={[
                                { value: 'simple', label: 'Simple' },
                                { value: 'complex', label: 'Complex' },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            size="large"
                            block
                            style={{
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                            }}
                            >
                                Save Changes
                            </Button>
                            <Button>Cancel</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default AddTruck;